import { useState } from "react";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";

import BackIcon from "assets/icons/back.svg?react";
import ArrowLeftIcon from "assets/icons/arrow_l.svg?react";
import settingService from "api/settingsService";
import Input from "components/Input";
import HollowButton from "components/HollowButton";
import Button from "components/Button";
import { useTranslation } from "react-i18next";

const ChangePhone: FC<Props> = ({ onCanceled, onSaved, phone: phoneUser }) => {
  const { t } = useTranslation();
  const [phone, setPhone] = useState(phoneUser);
  const { mutate: updatePhone } = settingService.useSetPersonal();

  const save = () => {
    updatePhone(
      { Phone: phone },
      {
        onSuccess: () => {
          onSaved();
        },
      }
    );
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.pathBar}>
        <div className={styles.backButton}>
          <BackIcon onClick={onCanceled}></BackIcon>
        </div>
        {t("changePassword.basicData")} <ArrowLeftIcon></ArrowLeftIcon> {t("changePhone.changePhone")}
      </div>

      <div className={styles.hint}>
        {t("settings.changePhoneDescription")}
      </div>
      <div className={styles.formWrapper}>
        <div className={styles.form}>
          <Input
            type="text"
            label={t("forms.phoneNumber")}
            onChange={(v) => setPhone(v)}
            value={phone}
            name="currentPassword"
          ></Input>
        </div>
      </div>
      <div className={styles.buttons}>
        <HollowButton text={t("common.cancel")} onClick={onCanceled}></HollowButton>
        <Button text={t("common.save")} onClick={save}></Button>
      </div>
    </div>
  );
};

export default ChangePhone;
